import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Container } from './styles'
import HeaderPlatform from '../../components/HeaderPlataform'
import Menu from '../../components/Menu'
// import { useSelector } from 'react-redux'
// import { StoreState } from '../../store'
// import api from '../../services/axios'
// import { agendaResponse } from '../../store/modules/auth/actions'
// import { useDispatch } from 'react-redux'
// import UpdatingAgenda from '../../components/UpdatingAgenda'
// import { get } from 'lodash'
// import { toast } from 'react-hot-toast'
// import dayjs from '../../libs/dayjs'

// somente para testes
export default function Plataform() {
    // const { solicitouAgendaHoje, cnpj_cpf } = useSelector(
    //     (state: StoreState) => state.auth.user
    // )
    // const dispatch = useDispatch()
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    // const [isLoading, setIsLoading] = useState(false)
    // const { currentLink } = useSelector((state: StoreState) => state.menu)
    // const navigate = useNavigate()
    // useEffect(() => {
    //   navigate(currentLink)
    // }, [navigate, currentLink])

    // useEffect(() => {
    //     if (!solicitouAgendaHoje) {
    //         // se o usuário ainda não entrou hoje (primeira login)
    //         // então vamos pedir a agenda dele
    //         const diaDaSemana = dayjs().day()
    //         if (diaDaSemana === 0 || diaDaSemana === 6) {
    //             toast.error(
    //                 'Não é possível solicitar a agenda nos finais de semana.'
    //             )
    //             return
    //         }

    //         // a agenda está disponível apenas entre as 9 horas da manha e as 20 horas da noite
    //         const timeOfDay = dayjs().hour()

    //         if (timeOfDay < 9 || timeOfDay > 19) {
    //             toast.error(
    //                 'O horario de disponibilidade para solicitar a agenda é após as 9 horas ou antes das 20 horas.'
    //             )
    //             return
    //         }

    //         setIsLoading(true)
    //         api.post('/agenda/solicitar', {
    //             cnpj_cpf: cnpj_cpf,
    //         })
    //             .then(({ data }) => {
    //                 setIsLoading(false)
    //                 dispatch(agendaResponse({ solicitouAgendaHoje: true }))
    //                 // alterar variavel no redux para true
    //             })
    //             .catch((data) => {
    //                 const message = get(data, 'response.data.error', '')
    //                 toast.error(message)

    //                 setIsLoading(false)

    //                 // alterar variavel no redux para false
    //             })
    //     }
    // }, [solicitouAgendaHoje, cnpj_cpf, dispatch])

    return (
        <Container className={isMenuOpen ? 'open' : 'close'}>
            <HeaderPlatform
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen}
            />
            <Menu setIsMenuOpen={setIsMenuOpen} isMenuOpen={isMenuOpen} />
            {/* <main>{isLoading ? <UpdatingAgenda /> : <Outlet />}</main> */}
            <main>
                <Outlet />
            </main>
        </Container>
    )
}
